import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { navigateTo } from "../utils/navigation";
import { toast } from "react-toastify";
import featureFlags from "../config/featureFlags";
/**
 * Merchant detail page redirect hook
 * - Redirects unauthenticated users to login
 * - Handles merchant & user flow
 */
const useMerchantDetailRedirect = (merchantId) => {
  const { user, accessToken } = useSelector((state) => state.merchant);
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;

    /* =====================
       NOT LOGGED IN
    ====================== */
    if (!accessToken || !user) {
      hasRedirected.current = true;
      toast.info("Please login to view merchant details");
      navigateTo("/merchant-login");
      return;
    }

    if (!merchantId) return;

    hasRedirected.current = true;

    /* =====================
       MERCHANT FLOW
    ====================== */
    if (user.role === "merchant") {

      if (!user.isEnquiryCompleted) {
        toast.info("Please complete the Merchant Inquiry");
        navigateTo("/merchant-inquiry");
        return;
      }

      if (user.enquiryStatus === "incomplete") {
        toast.info("Wait for the Approval of requested merchant inquiry");
        navigateTo("/inquiry-status");
        return;
      }

      if (user.enquiryStatus === "paymentPending") {
        if (featureFlags.ENABLE_MERCHANT_SUBSCRIPTION) {
          toast.info("Please purchase a subscription to view this page");
          navigateTo("/buy-subscription");
          return;
        }
        navigateTo(`/merchant-detail/${merchantId}`);
        return;
      }

      if (user.enquiryStatus === "paymentComplete") {
        navigateTo(`/merchant-detail/${merchantId}`);
        return;
      }

      navigateTo("/merchant-login");
      return;
    }

    /* =====================
       USER FLOW
    ====================== */
    if (user.role === "user") {

      if (!user.isEnquiryCompleted) {
    toast.info("Complete your profile");
        navigateTo("/profile");
        return;
      }

      if (user.enquiryStatus === "incomplete") {
        if (featureFlags.ENABLE_USER_SUBSCRIPTION) {
          toast.info("Please purchase a subscription to view this page");
          navigateTo("/buy-subscription");
          return;
        }
        navigateTo(`/merchant-detail/${merchantId}`);
        return;
      }

      if (user.enquiryStatus === "paymentComplete") {
        navigateTo(`/merchant-detail/${merchantId}`);
        return;
      }

      navigateTo("/merchant-login");
    }

  }, [user, accessToken, merchantId]);
};

export default useMerchantDetailRedirect;
